<!--
     <FieldLink>
-->

<template>
    <a :href="representation" target="_blank">{{ representation }}</a>
</template>
  
<script>
    export default {
     name: 'FielLink',
    
     props: ['field'],
    
     computed: {
       representation() {
         return '' + this.field.value;
       },
     },
    };
</script>